import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import Link from "../Link";

var FilterItem = function FilterItem(_ref) {
  var borderless = _ref.borderless,
      children = _ref.children,
      disabled = _ref.disabled,
      href = _ref.href;
  var getClassName = getClassNameFactory("SearchFiltersFilterItem");
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      modifiers: borderless ? "borderless" : ""
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "link"
    })
  }, /*#__PURE__*/React.createElement(Link, {
    href: disabled ? "" : href,
    disabled: disabled
  }, children)));
};

FilterItem.displayName = "SearchFilters.FilterItem";
export default FilterItem;